/**
 * Highlight color spectrum for text entities and emphasis.
 * 900: #136777, 800: #02C7D4 (user-specified).
 */
const highlight = {
  25: '#F7FDFE',
  50: '#F0FCFD',
  100: '#E0F9FB',
  200: '#BFF3F6',
  300: '#8EE8ED',
  400: '#5DDCE4',
  500: '#2ACDD8',
  600: '#0EB8C4',
  700: '#089AA6',
  800: '#02C7D4',
  900: '#136777',
};
export default highlight;
